<script>
/**
 * Stat component -- specify the widget icon, title and value.
 */
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    value1: {
      type: String,
      default: ""
    },
    value2: {
      type: String,
      default: ""
    },
    text1: {
      type: String,
      default: ""
    },
    text2: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    bg: {
      type: String,
      default: ""
    },

  }
};
</script>

<template>
  <div class="card mini-stats-wid">
    <div class="card-body p-4">
        <div class="media">
          <div class="media-body">
            <p class="text-warning font-size-16 font-weight-bold">{{title}}</p>
            <div class="row">
              <div :class="value2   ? 'col-6' : 'col-12'">
                <h5 class="mb-0" :class="value1  ? 'text-dark' : ''">{{!value1 ? '-' : value1}}</h5><span class="text-dark">{{text1}}</span>
              </div>
              <div  :class="value1 ? 'col-6' : 'col-12'" v-show="value2">
                <h5 class="mb-0" :class="value2  ? 'text-dark' : ''">{{!value2 ? '-' : value2}}</h5><span class="text-dark">{{text2}}</span>
              </div>

            </div>
          </div>
          <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
            <span :class="`avatar-title ${bg}`">
              <i :class="`${icon} font-size-24 text-white`"></i>
            </span>
          </div>
        </div>


    </div>
    <!-- end card-body -->
  </div>
  <!-- end card -->
</template>